import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    constructor(

    ) {
    }
    static PARAM = environment.PARAM;
    CDN_BASE = environment.CDN_BASE;
    HTTP_RESPONSE = environment.HTTP_RESPONSE;

    previwFile(rutaarchivo): string {
        return this.CDN_BASE + rutaarchivo;
    }

    /* ------------------------------------------------------------------
     * Utilidades de fecha NATIVAS (reemplazo de moment.js).
     * Producen exactamente los mismos valores que moment() para los
     * formatos usados en el proyecto: YYYY/yyyy/MM/DD/HH/hh/mm/ss/A/L.
     * Las cadenas 'YYYY-MM-DD' se interpretan en hora local (como moment).
     * ------------------------------------------------------------------ */

    private static pad2(n: number): string {
        return (n < 10 ? '0' : '') + n;
    }

    /** Replica exacta de isNumeric de rxjs/internal-compatibility. */
    private static esNumerico(val: any): boolean {
        // tslint:disable-next-line:triple-equals
        return !Array.isArray(val) && (val - parseFloat(val) + 1) >= 0;
    }

    private static aFechaLocal(fecha: any): Date | null {
        if (fecha instanceof Date) {
            return isNaN(fecha.getTime()) ? null : new Date(fecha.getTime());
        }
        if (typeof fecha === 'number') {
            return isNaN(new Date(fecha).getTime()) ? null : new Date(fecha);
        }
        if (typeof fecha === 'string') {
            const texto = fecha.trim();
            let m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
            if (m) {
                return new Date(+m[1], +m[2] - 1, +m[3]);
            }
            m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(texto);
            if (m) {
                return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
            }
        }
        const d = new Date(fecha);
        return isNaN(d.getTime()) ? null : d;
    }

    private static aplicarFormato(d: Date, formato: string): string {
        const y = d.getFullYear();
        const M = UtilityService.pad2(d.getMonth() + 1);
        const D = UtilityService.pad2(d.getDate());
        const H24 = UtilityService.pad2(d.getHours());
        const h12 = d.getHours() % 12 || 12;
        const H12 = UtilityService.pad2(h12);
        const mi = UtilityService.pad2(d.getMinutes());
        const ss = UtilityService.pad2(d.getSeconds());
        return formato.replace(/YYYY|yyyy|YY|MM|DD|HH|hh|mm|ss|A|a|L/g, (token) => {
            switch (token) {
                case 'YYYY':
                case 'yyyy': return String(y);
                case 'YY': return String(y).slice(-2);
                case 'MM': return M;
                case 'DD': return D;
                case 'HH': return H24;
                case 'hh': return H12;
                case 'mm': return mi;
                case 'ss': return ss;
                case 'A': return d.getHours() < 12 ? 'AM' : 'PM';
                case 'a': return d.getHours() < 12 ? 'am' : 'pm';
                case 'L': return M + '/' + D + '/' + y;
                default: return token;
            }
        });
    }

    private static inicioDelDia(fecha: any): Date | null {
        const d = UtilityService.aFechaLocal(fecha);
        if (!d) { return null; }
        d.setHours(0, 0, 0, 0);
        return d;
    }

    private static sumarMeses(d: Date, meses: number): Date {
        const dia = d.getDate();
        const r = new Date(d.getTime());
        r.setDate(1);
        r.setMonth(r.getMonth() + meses);
        const maxDia = new Date(r.getFullYear(), r.getMonth() + 1, 0).getDate();
        r.setDate(Math.min(dia, maxDia));
        return r;
    }

    /** Equivale a moment(a).isBefore(b, 'day'). */
    public static esAntesPorDia(a: any, b: any): boolean {
        const da = UtilityService.inicioDelDia(a);
        const db = UtilityService.inicioDelDia(b);
        if (!da || !db) { return false; }
        return da.getTime() < db.getTime();
    }

    /** Equivale a moment(a).isAfter(b, 'day'). */
    public static esDespuesPorDia(a: any, b: any): boolean {
        const da = UtilityService.inicioDelDia(a);
        const db = UtilityService.inicioDelDia(b);
        if (!da || !db) { return false; }
        return da.getTime() > db.getTime();
    }

    /** Equivale a moment(a).diff(b, 'days') (trunca hacia cero). */
    public static diferenciaEnDias(a: any, b: any): number {
        const da = UtilityService.aFechaLocal(a);
        const db = UtilityService.aFechaLocal(b);
        if (!da || !db) { return 0; }
        const v = (da.getTime() - db.getTime()) / 86400000;
        return v >= 0 ? Math.floor(v) : Math.ceil(v);
    }

    /**
     * Fecha fin de contrato: inicio + cantidad (d=dias, m=meses, a=anos)
     * menos 1 dia. Equivale a moment(inicio).add(c, u).subtract(1, 'days').
     */
    public static calcularFechaFinContrato(fechaInicio: any, cantidad: number, tipotiempo: string): Date | null {
        const d = UtilityService.aFechaLocal(fechaInicio);
        if (!d || !cantidad || !tipotiempo) { return null; }
        let r: Date;
        if (tipotiempo === 'd') {
            r = new Date(d.getTime());
            r.setDate(r.getDate() + cantidad);
        } else if (tipotiempo === 'm') {
            r = UtilityService.sumarMeses(d, cantidad);
        } else if (tipotiempo === 'a') {
            r = UtilityService.sumarMeses(d, cantidad * 12);
        } else {
            return null;
        }
        r.setDate(r.getDate() - 1);
        return r;
    }

    public static formatearFecha(fecha, formato): any {
        let fechaSeteada = "";
        if (fecha && fecha !== '-') {
            const d = UtilityService.aFechaLocal(fecha);
            fechaSeteada = d ? UtilityService.aplicarFormato(d, formato) : 'Invalid date';
        }
        return fechaSeteada;
    }

    public static esUnIDValido(id: string) {
        return UtilityService.esNumerico(id) && parseInt(id) > 0;
    }

    public static listaEstadoFiltros(): any[] {
        return [
            {id: "-1", value: "Todos..."},
            {id: "1", value: "Activos"},
            {id: "0", value: "Inactivos"}
        ];
    }

    public static obtenerListaDiasDeLaSemana() {
        return [
            {value: '1', label: 'Lunes'},
            {value: '2', label: 'Martes'},
            {value: '3', label: 'Miercoles'},
            {value: '4', label: 'Jueves'},
            {value: '5', label: 'Viernes'},
            {value: '6', label: 'Sábado'},
            {value: '7', label: 'Domingo'}
        ];
    }

    public obtenerArregloCategoriasInforme() {

        const CategoriasList =
            [
                {
                    categoria_id: 1,
                    nombre: 'Informes para BASC',
                    descripcion: 'Diversos informes que brindan información relacionada con el trabajador.'
                },
                {
                    categoria_id: 2,
                    nombre: 'Informes del Personal',
                    descripcion: 'Diversos informes que brindan información relacionada con el trabajador.'
                },
                {
                    categoria_id: 3,
                    nombre: 'Reporte de Gestión',
                    descripcion: 'Reportes de gestión en construcción.'
                }
            ];
        return CategoriasList;
    }

    public obtenerArregloInformesGenerales() {
        const reporteList =
            [
                {
                    informe_id: 1,
                    descripcion: 'Usuarios y Accesos Asignados',
                    url: '',
                    page: 'trabajador_reporteprivilegios',
                    categoria_id: 1,
                    type: 'reports'
                },
                {
                    informe_id: 2,
                    descripcion: 'Plan de Mantenimiento',
                    url: '',
                    page: 'trabajador_reportemantenimiento',
                    categoria_id: 1,
                    type: 'reports'
                },
                {
                    informe_id: 3,
                    descripcion: 'Cambio de Claves',
                    url: '',
                    page: 'trabajador_reporteclaves',
                    categoria_id: 1,
                    type: 'reports'
                },
                {
                    informe_id: 4,
                    descripcion: 'Inventario de Equipos',
                    url: '',
                    page: 'trabajador_reporteinventarioequipo',
                    categoria_id: 1,
                    type: 'reports'
                },
                {
                    informe_id: 5,
                    descripcion: 'Inspección de Equipos',
                    url: '',
                    page: 'trabajador_reporteinspeccion',
                    categoria_id: 1,
                    type: 'reports'
                },
                {
                    informe_id: 6,
                    descripcion: 'Reporte del Personal',
                    url: '/reportes/datapersonal/',
                    page: '',
                    categoria_id: 2,
                    type: 'page'
                },
                {
                    informe_id: 7,
                    descripcion: 'Mantenimiento Correctivo de Equipos',
                    url: '/reportes/gestion/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 8,
                    descripcion: 'Inventario Desuso',
                    url: '/reportes/desuso/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 9,
                    descripcion: 'Registro de Backups de Servidores Administrativos',
                    url: '/reportes/backups/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 10,
                    descripcion: 'Control de Cambio de Claves de los Usuarios',
                    url: '/reportes/controlclaves/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 11,
                    descripcion: 'Registro de Inspección de Equipo Informático de Usuario',
                    url: '/reportes/inspeccionequipo/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 12,
                    descripcion: 'Plan de Mantenimiento Periódico de Equipos Informáticos',
                    url: '/reportes/mantenimientoequipo/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 13,
                    descripcion: 'Inventario de Equipos Informáticos en Uso',
                    url: '/reportes/inventarioequipos/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 14,
                    descripcion: 'Registro de Usuarios y Accesos Asignados',
                    url: '/reportes/usuarioaccesos/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 15,
                    descripcion: 'Registro de Pruebas de Seguridad de Sistemas',
                    url: '/reportes/pruebaseguridad/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                },
                {
                    informe_id: 16,
                    descripcion: 'Control de Simulacros de Phishing',
                    url: '/reportes/simulacrophishing/',
                    page: '',
                    categoria_id: 3,
                    type: 'page'
                }
            ];

        return reporteList;
    }

    /**
     * Metodo que valida si una imagen es de cloudinary para asignarle el path del CDN o no
     * @param urlImagen
     */

    public static obtenerCDNBaseImagen(urlImagen, dimensiones?) {
        if (urlImagen.startsWith('galery/')) {
            if (dimensiones) {
                return environment.CDN_CLOUDINARY + dimensiones + urlImagen;
            }
            return environment.CDN_CLOUDINARY + urlImagen;
        }
        return urlImagen;
    }

    public static jsonTranslateEspanol() {
        return {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
            today: 'Hoy',
            clear: 'Borrar'
        };
    }

    public static round(value, exp) {
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math.round(value);
        }
        value = this.round2(value, exp + 2);
        value = +value;
        exp = +exp;
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
    }

    public static round2(value, exp) {
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math.round(value);
        }
        value = +value;
        exp = +exp;
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
    }

    public static obtenerListaComprobantes(conTodos?) {
        const listaComprobantes = [];
        if (conTodos == this.PARAM.SI) {
            listaComprobantes.push({label: 'Todos', value: this.PARAM.TODOS, icon: 'fa fa-fw fa-book'});
        }
        listaComprobantes.push({label: 'Factura', value: 'Factura', icon: 'fa fa-fw fa-book'});
        listaComprobantes.push({label: 'Boleta', value: 'Boleta', icon: 'fa fa-fw fa-book'});
        return listaComprobantes;
    }

    public static obtenerRangofechasFormateada(listaRangoFechas) {
        const rangoFechas: any = {};
        rangoFechas.fechaInicial = this.PARAM.TODOS;
        rangoFechas.fechaFinal = this.PARAM.TODOS;
        if (Array.isArray(listaRangoFechas) && listaRangoFechas.length > 1) {
            rangoFechas.fechaInicial = UtilityService.formatearFecha(listaRangoFechas[0], 'yyyy-MM-DD 00:00:00');
            rangoFechas.fechaFinal = UtilityService.formatearFecha(listaRangoFechas[1], 'yyyy-MM-DD 23:59:59');
        }
        return rangoFechas;
    }

    public static obtenerInicioDeMesFormatoDate() {
        const fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    public static obtenerListaIsocode(conTodos?): any[] {
        const listaIsocode = [];
        if (conTodos == this.PARAM.SI) {
            listaIsocode.push({label: 'Todos', value: this.PARAM.TODOS});
        }
        listaIsocode.push({label: 'PEN', value: 'PEN'});
        listaIsocode.push({label: 'USD', value: 'USD'});
        listaIsocode.push({label: 'EUR', value: 'EUR'});
        return listaIsocode;
    }

    public static obtenerListaEstadosOrdecompra(conTodos?) {
        const listaEstadoOrdencompra = [];
        if (conTodos == this.PARAM.SI) {
            listaEstadoOrdencompra.push({label: 'Todos', value: this.PARAM.TODOS});
        }
        listaEstadoOrdencompra.push({label: 'Anulados', value: '0'});
        listaEstadoOrdencompra.push({label: 'Nuevos', value: '1'});
        listaEstadoOrdencompra.push({label: 'Confirmados', value: '2'});
        listaEstadoOrdencompra.push({label: 'En camino', value: '3'});
        listaEstadoOrdencompra.push({label: 'Entregado', value: '4'});
        return listaEstadoOrdencompra;
    }

    public static obtenerListaEstadosInactivosActivos(conTodos?) {
        const listaEstadoOrdencompra = [];
        if (conTodos == this.PARAM.SI) {
            listaEstadoOrdencompra.push({label: 'Todas', value: this.PARAM.TODOS});
        }
        listaEstadoOrdencompra.push({label: 'Anuladas', value: '0'});
        listaEstadoOrdencompra.push({label: 'Activas', value: '1'});
        return listaEstadoOrdencompra;
    }

    public static obtenerListaMeses() {
        return [{
            label: 'Enero',
            value: 1
        }, {
            label: 'Febrero',
            value: 2
        }, {
            label: 'Marzo',
            value: 3
        }, {
            label: 'Abril',
            value: 4
        }, {
            label: 'Mayo',
            value: 5
        }, {
            label: 'Junio',
            value: 6
        }, {
            label: 'Julio',
            value: 7
        }, {
            label: 'Agosto',
            value: 8
        }, {
            label: 'Septiembre',
            value: 9
        }, {
            label: 'Octubre',
            value: 10
        }, {
            label: 'Noviembre',
            value: 11
        }, {
            label: 'Diciembre',
            value: 12
        }];
    }

    public static obtenerListaAnios() {
        const currentAnio = (new Date()).getFullYear();
        const anioList = [];
        for (let i = 2016; i < currentAnio; i++) {
            anioList.push({value: i, label: i});
        }
        anioList.push({value: currentAnio, label: currentAnio});
        for (let i = currentAnio + 1; i <= 2040; i++) {
            anioList.push({value: i, label: i});
        }

        return anioList;
    }

    public static obtenerListaUbicacionesPagina() {
        const listaUbicacionesPagina = [];
        listaUbicacionesPagina.push({label: 'Header', value: '1'});
        listaUbicacionesPagina.push({label: 'Footer', value: '2'});
        return listaUbicacionesPagina;
    }


    public formatearFechaParaVista(fecha): any {
        let fechaSeteada = null;
        if (fecha && fecha !== '-') {
            fechaSeteada = new Date(fecha + " " + "00:00:01");
        }
        return fechaSeteada;
    }

    /**
     * Validadores
     */

    public getPageOptions(): any[] {
        return [5, 10, 20, 30, 50, 100];
    }

    public obtenerFechaSegunFormato(fecha, formato): any {
        let fechaSeteada = "";
        if (fecha && fecha !== '-') {
            const d = UtilityService.aFechaLocal(fecha);
            fechaSeteada = d ? UtilityService.aplicarFormato(d, formato) : 'Invalid date';
        }
        return fechaSeteada;
    }

    public obtenerInicioDeMes() {
        const fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    public obtenerInicioDeSemana() {
        // Lunes 00:00 local (equivale a moment().startOf('week').add(1, 'day')).
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        hoy.setDate(hoy.getDate() - ((hoy.getDay() + 6) % 7));
        return hoy;
    }


    public validarInputSearch(busqueda) {
        if (busqueda != undefined && busqueda != null && busqueda != "") {
            if (!Number.isNaN(busqueda)) {
                return busqueda;
            } else {

                const texto = busqueda.replace(/[^\w\s]/gi, '');
                if (texto == '') {
                    return UtilityService.PARAM.TODOS;
                }
                return texto;
            }

        }
        return UtilityService.PARAM.TODOS;
    }

    public getColorLine(valor){
        if (valor % 3 == 0){
            return "success";
        } else if (valor % 2 == 0){
            return "danger";
        } else {
          return "primary";
        }
    }

    public getGrupoDocumentos(){
        return [
            {
                id: '1',
                descripcion: 'Documentos Ingresos Vitae'
            },
            {
                id: '2',
                descripcion: 'Registros de Ingreso'
            },
            {
                id: '3',
                descripcion: 'Cargo de Entrega'
            },
            {
                id: '4',
                descripcion: 'Documentos Cese'
            }
        ];
    }

    public getDocumentos(){
        const arraydocumentos = [
            {
                id: '1',
                descripcion: 'Curriculum Vitae',
                grupo: '1'
            },
            {
                id: '2',
                descripcion: 'Certificados de Estudios y Trabajos',
                grupo: '1'
            },
            {
                id: '3',
                descripcion: 'Foto para Fotocheck',
                grupo: '1'
            },
            {
                id: '4',
                descripcion: 'Copia DNI',
                grupo: '1'
            },
            {
                id: '5',
                descripcion: 'Copia DNI derechohabientes',
                grupo: '1'
            },
            {
                id: '6',
                descripcion: 'Partido de matrimonio / Escritura de union de hecho',
                grupo: '1'
            },
            {
                id: '7',
                descripcion: 'Antecedentes Policiales',
                grupo: '1'
            },
            {
                id: '8',
                descripcion: 'Antecedentes Penales',
                grupo: '1'
            },
            {
                id: '9',
                descripcion: 'Certificado 5ta Categoría',
                grupo: '1'
            },
            {
                id: '10',
                descripcion: 'Elección Sistema De Pensiones',
                grupo: '1'
            },
            {
                id: '11',
                descripcion: 'Copia de Recibo de Luz / Agua',
                grupo: '1'
            },
            {
                id: '12',
                descripcion: 'Fotos Fachada Domicilio',
                grupo: '1'
            },
            {
                id: '13',
                descripcion: 'DJ Antecedentes Personales, Laborales y Patrimoniales',
                grupo: '2'
            },
            {
                id: '14',
                descripcion: 'Actualización de Identificación del Empleado',
                grupo: '2'
            },
            {
                id: '15',
                descripcion: 'DJ de Domicilio',
                grupo: '2'
            },
            {
                id: '16',
                descripcion: 'Autorización de Visita Domiciliaria',
                grupo: '2'
            },
            {
                id: '17',
                descripcion: 'DJ de Elección de Sistema Pensionario',
                grupo: '2'
            },
            {
                id: '18',
                descripcion: 'Solicitud de Asignación Familiar',
                grupo: '2'
            },
            {
                id: '19',
                descripcion: 'Ficha de Sintomatología',
                grupo: '2'
            },
            {
                id: '20',
                descripcion: 'Elección de Banco Sueldo y CTS',
                grupo: '2'
            },
            {
                id: '21',
                descripcion: 'DACHA-UIF-M-01 Prevención LA-FT v.2',
                grupo: '3'
            },
            {
                id: '22',
                descripcion: 'DACHA-UIF-C-01 Codigo de Conducta',
                grupo: '3'
            },
            {
                id: '23',
                descripcion: 'RIT Chavimochic',
                grupo: '3'
            },
            {
                id: '24',
                descripcion: 'RISST Chavimochic',
                grupo: '3'
            },
            {
                id: '25',
                descripcion: 'Contrato de trabajo',
                grupo: '3'
            },
            {
                id: '26',
                descripcion: 'Compromiso de confindencialidad',
                grupo: '3'
            },
            {
                id: '27',
                descripcion: 'Carta oferta',
                grupo: '3'
            },
            {
                id: '28',
                descripcion: 'Recomendaciones de SST',
                grupo: '3'
            },
            {
                id: '29',
                descripcion: 'Registro de inducción',
                grupo: '3'
            },
            {
                id: '30',
                descripcion: 'Anexo 09 / lavado de activos',
                grupo: '3'
            },
            {
                id: '31',
                descripcion: 'Memorandum de Iturri APP',
                grupo: '3'
            },
            {
                id: '32',
                descripcion: 'EMO',
                grupo: '3'
            },
            {
                id: '33',
                descripcion: 'Entrevista de salida',
                grupo: '4'
            },
            {
                id: '34',
                descripcion: 'Carta de renuncia',
                grupo: '4'
            },
            {
                id: '35',
                descripcion: 'Notificación de Cese',
                grupo: '4'
            },
            {
                id: '36',
                descripcion: 'Correo de baja',
                grupo: '4'
            }
        ];

        return arraydocumentos;
    }

    public getDocumentoText(documentotipo) {
        const documentoList = this.getDocumentos();
        for (const documento of documentoList) {
            if (documentotipo == documento.id){
                return documento.descripcion;
            }
        }

        return null;
    }

    /**
     * Parsers data
     */
    /**
     * Devuelve una respuesta de error cuando 'data' es un fallo de HTTP; null
     * si no lo es. Usa el mensaje que mando el servidor si vino en el cuerpo.
     */
    private parseErrorHttp(data, tablaDescripcion?: string, tablaId?: string): any {
        const esErrorHttp = data instanceof HttpErrorResponse ||
            (data !== null && typeof data === 'object' && data.ok === false && typeof data.status === 'number');
        if (!esErrorHttp) {
            return null;
        }

        const cuerpo = data.error;
        if (cuerpo !== null && typeof cuerpo === 'object' && cuerpo.tipo && cuerpo.mensajes) {
            const mensajes = Array.isArray(cuerpo.mensajes) ? cuerpo.mensajes : [cuerpo.mensajes];
            return {
                tipo: cuerpo.tipo,
                mensajes: this.parseResponseErrorDatabase(mensajes, tablaDescripcion, tablaId),
                data: null
            };
        }

        const detalle = data.status === 0
            ? 'No se pudo conectar con el servidor.'
            : 'El servidor respondio con un error ' + data.status + '.';
        return {tipo: this.HTTP_RESPONSE.ERROR, mensajes: [detalle + ' Intentalo de nuevo.'], data: null};
    }

    public parseData(data, tablaDescripcion?: string, tablaId?: string): any {
        /**
         * Si la peticion fallo (500, 404, timeout...) hay que cortar aca. Mas
         * abajo, una respuesta sin 'tipo' ni 'mensajes' se toma como exito, asi
         * que un error HTTP terminaria mostrandose como operacion correcta.
         */
        const errorHttp = this.parseErrorHttp(data, tablaDescripcion, tablaId);
        if (errorHttp) {
            return errorHttp;
        }

        let dataObj = {tipo: this.HTTP_RESPONSE.MALFORMED_JSON, mensajes: ['JSON mal formado', data], data: null};
        if (data !== null && typeof data === 'object') {
            if (data.data !== null && typeof data.data === 'object') {
                dataObj = data;
                if (!data.tipo) {
                    dataObj.tipo = this.HTTP_RESPONSE.SUCCESS;
                }
            } else {
                /**
                 * Si la respuesta es pura sin tipo ni mensajes seteo data a la respuesta
                 */
                if (data.data && data.tipo && data.mensajes) {
                    dataObj = data;
                } else {
                    if (!data.tipo && !data.mensajes) {
                        dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [], data};
                        if (data.mensajes && Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: data.mensajes, data};
                        }
                        if (data.mensajes && !Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [data.mensajes], data};
                        }
                    } else {
                        if (data.tipo === this.HTTP_RESPONSE.PERMISION_ERROR) {
                            dataObj = data;
                        }
                        if (data.tipo === this.HTTP_RESPONSE.SUCCESS) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.WARNING) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.INFO) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.ERROR) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                /**
                                 * Si la respuesta tiene alguno de los siguientes problemas parseo
                                 * la respuesta indicando el origen del problema
                                 */
                                    // tslint:disable-next-line:max-line-length
                                const mensajeServidorError = this.parseResponseErrorDatabase(data.mensajes, tablaDescripcion, tablaId);
                                dataObj = {tipo: data.tipo, mensajes: mensajeServidorError, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                    }
                }
            }
        }
        return dataObj;
    }

    public parseDataAPI(data, tablaDescripcion?: string, tablaId?: string): any {
        return data;
    }

    public parseResponseErrorDatabase(mensajes: any[], tablaDescripcion: string, tablaId: string) {
        let mensajeArrayProcesada = [];

        mensajes.forEach(error => {
            /**
             * Pregunto si el error es por algun fk delete
             */
            if (error.includes('Cannot delete or update a parent row: a foreign key constraint fails')) {
                // tslint:disable-next-line:max-line-length
                mensajeArrayProcesada.push('El elemento con ID "' + tablaId + '" de la tabla "' + tablaDescripcion + '" está referenciado en otra(s) tabla(s), ' +
                    'por favor contacta al admininistrador para notificar el problema e ' +
                    'indicale el id y la tabla que tienen problemas.');
            }
        });

        if (!mensajeArrayProcesada.length) {
            mensajeArrayProcesada = mensajes;
        }

        return mensajeArrayProcesada;
    }

    /**
     * Formatos de fecha
     */
    public obtenerFechaActual(): any {
        return UtilityService.formatearFecha(new Date(), 'L');
    }

    public obtenerFechaHoraActual(): any {
        return UtilityService.formatearFecha(new Date(), 'YYYY-MM-DD HH:mm:ss');
    }
    public obtenerHoraActual(): any {
        return UtilityService.formatearFecha(new Date(), 'HH:mm');
    }

    public formatearFechaYHora(fecha, hora) {
        return UtilityService.formatearFecha(fecha, 'YYYY-MM-DD') + ' ' + hora;
    }

    public obtenerListaBloquePanelimagen(): any {
        return [
            {
                id: '0',
                value: 'Bloque ofertas (Superior)'
            },
            {
                id: '1',
                value: 'Bloque ofertas (Inferior)'
            },
            {
                id: '2',
                value: 'Bloque productos por identificador'
            }
        ];
    }

    public obtenerListaColumnasBloquePanelimagen(): any {
        return [
            {
                id: '1',
                value: 'Ocupa 1 columna'
            },
            {
                id: '2',
                value: 'Ocupa 2 columnas'
            },
            {
                id: '3',
                value: 'Ocupa 3 columnas'
            },
            {
                id: '4',
                value: 'Ocupa 4 columna'
            },
            {
                id: '5',
                value: 'Ocupa 5 columnas'
            },
            {
                id: '6',
                value: 'Ocupa 6 columnas'
            },
            {
                id: '7',
                value: 'Ocupa 7 columna'
            },
            {
                id: '8',
                value: 'Ocupa 8 columnas'
            },
            {
                id: '9',
                value: 'Ocupa 9 columnas'
            },
            {
                id: '10',
                value: 'Ocupa 10 columna'
            },
            {
                id: '11',
                value: 'Ocupa 11 columnas'
            },
            {
                id: '12',
                value: 'Ocupa 12 columnas'
            }
        ];
    }

    public obtenerPaletaColores(): any {
        return [
            {id: "1", color: "#000000"},
            {id: "2", color: "#2E64FE"},
            {id: "3", color: "#DF0101"},
            {id: "4", color: "#088A4B"},
            {id: "5", color: "#FF0080"},
            {id: "6", color: "#FA5858"},
            {id: "7", color: "#086A87"},
            {id: "8", color: "#FA5882"},
            {id: "9", color: "#DBA901"},
            {id: "10", color: "#2E9AFE"},
            {id: "11", color: "#EE7115"},
            {id: "12", color: "#20D860"},
            {id: "13", color: "#D779D4"},
            {id: "14", color: "#C77557"},
            {id: "15", color: "#F6E10C"},
        ];
    }

    public ubicarPuntoCentralDentroDeAreaEspecifica(array_points) {

        const puntoCentral = {
            latitud: null,
            longitud: null,
        };

        let latitudMin = array_points[0].latitude * 1;
        let longitudMin = array_points[0].longitude * 1;

        let latitudMax = array_points[0].latitude * 1;
        let longitudMax = array_points[0].longitude * 1;

        for (let i = 0; i < array_points.length; i++) {

            const point = array_points[i];

            if (latitudMin < point.latitude * 1) {
                latitudMin = point.latitude * 1;
            }
            if (latitudMax > point.latitude * 1) {
                latitudMax = point.latitude * 1;
            }

            if (longitudMin < point.longitude * 1) {
                longitudMin = point.longitude * 1;
            }
            if (longitudMax > point.longitude * 1) {
                longitudMax = point.longitude * 1;
            }
        }

        puntoCentral.latitud = (latitudMin + latitudMax) / 2;
        puntoCentral.longitud = (longitudMin + longitudMax) / 2;

        return puntoCentral;
    }

    public cantidadMaximaDigitosInputs() {
        return 9;
    }

    public formatoNumero(amount, decimales?) {
        const respaldo = amount;
        const decimals = Number(decimales) >= 0 ? decimales : 2;
        amount += '';
        if (amount === 'NaN' || amount === 'undefined' || amount === 'Infinity') {
            amount = '0';
        }
        if (isNaN(amount)) {
            return respaldo;
        }

        amount = parseFloat(amount); // convierte a numero
        amount = UtilityService.round(amount, decimals); // devuelve un string
        const codIdioma = this.obtenerIdiomaLocal();
        amount = (amount).toLocaleString(codIdioma, {minimumFractionDigits: decimals}); // retorna string
        return amount;
    }

    public obtenerIdiomaLocal() {
        // const localStorage = SecurityService.obtenerLocalActual();
        // if (localStorage) {
        //    return localStorage.local_idioma;
        // }
        return 'en-IN';
    }

    public obtenerFormatoVistaAMPM(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM/yyyy') + ' ' + UtilityService.formatearFecha(fecha, 'hh:mm A');
    }

    public obtenerFormatoVistaDiaMes(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM');
    }

    public obtenerFormatoVistaDDMMYYY(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM/yyyy');
    }

    public obtenerFormatoBD(fecha) {
        return UtilityService.formatearFecha(fecha, 'yyyy-MM-DD');
    }

    public valorEstaVacio(valor){
        return (valor == null || valor == "");
    }

    public obtenerFormatoVistaHora(fecha) {
        return UtilityService.formatearFecha(fecha, 'hh:mm A');
    }
    public obtenerFormatoHoraBD(fecha) {
        return UtilityService.formatearFecha(fecha, 'HH:mm');
    }

    public obtenerAnioActual() {
        return new Date().getFullYear();
    }

    public obtenerPrecintoAduanaFinal(ordenServicio) {
        let precintoFinal = ordenServicio.ordenservicio_precintoaduana;

        if (ordenServicio.ordenservicio_precintoadicional2) {

            precintoFinal = ordenServicio.ordenservicio_precintoadicional2nombre;

        } else if (ordenServicio.ordenservicio_precintoadicional1) {

            precintoFinal = ordenServicio.ordenservicio_precintoadicional1nombre;

        } else if (ordenServicio.ordenservicio_precintofinal) {

            precintoFinal = ordenServicio.ordenservicio_precintofinal;

        }

        return precintoFinal;
    }

    public obtenerNombreTipoEmbarque(tipoembarque, nombreLargo = false) {
        let txt = "";
        switch (tipoembarque) {
            case '1':
                txt = nombreLargo ? "LOCAL DE EXPORTADOR" : "LEX";
                break;
            case '2':
                txt = nombreLargo ? "DEPOSITO TEMPORAL / ALEATORIO" : "DT";
                break;
            case '3':
                txt = nombreLargo ? "DEPOSITO TEMPORAL / ALEATORIO" : "AF. SINI";
                break;
        }
        return txt;

    }

    public obtenerNombreCanal(canal) {
        let txt = "";
        switch (canal) {
            case '1':
                txt = "ROJO";
                break;
            case '2':
                txt = "VERDE";
                break;
            default:
                txt = "SIN CANAL";
                break;
        }
        return txt;

    }

    public getPesoVGM(taraContenedor: number, pesoBruto: number) {
        return Number(taraContenedor) + Number(pesoBruto);
    }

    public getTaraCamion(pesocamion, pesoBruto) {
        if (pesocamion * 1 > pesoBruto * 1) {
            return pesocamion - pesoBruto;
        }
        else {
            return 0;
        }
    }

    public getObjForm(values): any{

        const arrayvalues = Object.entries(values);
        const objFormControl = {};

        for (const [entry, value]  of arrayvalues) {
            objFormControl[entry] = [value];
        }

        return objFormControl;
    }

    verArchivo(rutaarchivo){
        window.open(this.CDN_BASE + rutaarchivo, '_blank');
    }

    public formatDateView(dateTimeStr: string): string {
        const dateTime = new Date(dateTimeStr);

        if (isNaN(dateTime.getTime())) {
            throw new Error(`Fecha inválida: ${dateTimeStr}`);
        }

        const now = new Date();

        const isToday =
            now.getFullYear() === dateTime.getFullYear() &&
            now.getMonth() === dateTime.getMonth() &&
            now.getDate() === dateTime.getDate();

        const pad = (n: number) => n.toString().padStart(2, '0');

        const hours12 = dateTime.getHours() % 12 || 12;
        const minutes = pad(dateTime.getMinutes());
        const ampm = dateTime.getHours() >= 12 ? 'PM' : 'AM';

        if (isToday) {
            return `${hours12}:${minutes} ${ampm}`;
        } else {
            const day = pad(dateTime.getDate());
            const month = pad(dateTime.getMonth() + 1);
            const year = dateTime.getFullYear();
            return `${day}/${month}/${year} ${hours12}:${minutes} ${ampm}`;
        }
    }

    public mesATexto(mes: string): string {
        if(!mes || mes === "") { return mes; }
        const meses = [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
        ];

        return meses[Number(mes) - 1];
    }

    public formatearFechaTextoWord(fecha: string): string {
        if(!fecha || fecha === "") { return fecha; }
        const meses = [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre'
        ];

        const [anio, mes, dia] = fecha.split('-');

        return `${Number(dia)} de ${meses[Number(mes) - 1]} del ${anio}`;
    }

    public fechaHoyWord(){
        const hoy = new Date();
        return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
    }

    public numeroATexto(numero: number): string {
        const unidades = [
            '',
            'uno',
            'dos',
            'tres',
            'cuatro',
            'cinco',
            'seis',
            'siete',
            'ocho',
            'nueve'
        ];

        const especiales = [
            'diez',
            'once',
            'doce',
            'trece',
            'catorce',
            'quince',
            'dieciséis',
            'diecisiete',
            'dieciocho',
            'diecinueve'
        ];

        const decenas = [
            '',
            '',
            'veinte',
            'treinta',
            'cuarenta',
            'cincuenta',
            'sesenta',
            'setenta',
            'ochenta',
            'noventa'
        ];

        const centenas = [
            '',
            'ciento',
            'doscientos',
            'trescientos',
            'cuatrocientos',
            'quinientos',
            'seiscientos',
            'setecientos',
            'ochocientos',
            'novecientos'
        ];

        function convertirMenor100(n: number): string {
            if (n < 10) return unidades[n];
            if (n >= 10 && n < 20) return especiales[n - 10];
            if (n >= 20 && n < 30) {
                return n === 20
                    ? 'veinte'
                    : 'veinti' + unidades[n - 20];
            }

            const d = Math.floor(n / 10);
            const u = n % 10;

            return u === 0
                ? decenas[d]
                : `${decenas[d]} y ${unidades[u]}`;
        }

        function convertirMenor1000(n: number): string {
            if (n === 100) return 'cien';

            const c = Math.floor(n / 100);
            const resto = n % 100;

            return `${centenas[c]} ${convertirMenor100(resto)}`.trim();
        }

        function convertir(n: number): string {
            if (n === 0) return 'cero';

            if (n < 1000) {
                return convertirMenor1000(n);
            }

            if (n < 1000000) {
                const miles = Math.floor(n / 1000);
                const resto = n % 1000;

                const textoMiles =
                    miles === 1
                        ? 'mil'
                        : `${convertirMenor1000(miles)} mil`;

                return `${textoMiles} ${convertirMenor1000(resto)}`.trim();
            }

            return '';
        }

        return convertir(numero);
    }

    public montoATexto(monto: any) {
        console.log("montoATexto", monto);

        if(!monto || monto == "") { return monto; }

        monto = monto * 1;

        const entero = Math.floor(monto);
        const decimales = Math.round((monto - entero) * 100);

        const texto = this.numeroATexto(entero);

        // tslint:disable-next-line:max-line-length
        return `S/. ${monto.toFixed(2)} (${texto.charAt(0).toUpperCase() + texto.slice(1)} ${String(decimales).padStart(2, '0')}/100 Soles)`;
    }


    public numeroTexto(numero: number): string {
        const textos: { [key: number]: string } = {
            0: 'CERO',
            1: 'UNO',
            2: 'DOS',
            3: 'TRES',
            4: 'CUATRO',
            5: 'CINCO',
            6: 'SEIS',
            7: 'SIETE',
            8: 'OCHO',
            9: 'NUEVE',
            10: 'DIEZ',
            11: 'ONCE',
            12: 'DOCE'
        };

        return textos[numero] || numero.toString();
    }

    public calcularTiempoTexto(fechaInicio: any, fechaFin: any): string {
        if (!fechaInicio || !fechaFin) {
            return '';
        }

        const inicio = UtilityService.aFechaLocal(fechaInicio);
        const finInclusive = UtilityService.aFechaLocal(fechaFin);

        if (!inicio || !finInclusive || finInclusive.getTime() < inicio.getTime()) {
            return '';
        }

        // contrato_fechafin es el último día del contrato (rango inclusivo,
        // generado como inicio + cantidad - 1 día en calcularFechaFinContrato).
        // Se suma 1 día para medir la duración nominal (p.ej. exactamente
        // "3 meses") en vez de la diferencia calendario cruda entre límites.
        const fin = new Date(finInclusive.getTime());
        fin.setDate(fin.getDate() + 1);

        let anios = fin.getFullYear() - inicio.getFullYear();
        let meses = fin.getMonth() - inicio.getMonth();
        let dias = fin.getDate() - inicio.getDate();

        // Ajuste de días
        if (dias < 0) {
            meses--;

            const ultimoDiaMesAnterior = new Date(
                fin.getFullYear(),
                fin.getMonth(),
                0
            ).getDate();

            dias += ultimoDiaMesAnterior;
        }

        // Ajuste de meses
        if (meses < 0) {
            anios--;
            meses += 12;
        }

        const partes: string[] = [];

        if (anios > 0) {
            partes.push(
                `${this.numeroTexto(anios)} (${String(anios).padStart(2, '0')}) ${anios === 1 ? 'AÑO' : 'AÑOS'}`
            );
        }

        if (meses > 0) {
            partes.push(
                `${this.numeroTexto(meses)} (${String(meses).padStart(2, '0')}) ${meses === 1 ? 'MES' : 'MESES'}`
            );
        }

        if (dias > 0 || partes.length === 0) {
            partes.push(`${dias} DÍAS`);
        }

        return partes.join(' CON ');
    }

    unidades : string[] = [
        '',
        'UNO',
        'DOS',
        'TRES',
        'CUATRO',
        'CINCO',
        'SEIS',
        'SIETE',
        'OCHO',
        'NUEVE'
    ];

    especiales = [
        'DIEZ',
        'ONCE',
        'DOCE',
        'TRECE',
        'CATORCE',
        'QUINCE',
        'DIECISÉIS',
        'DIECISIETE',
        'DIECIOCHO',
        'DIECINUEVE'
    ];

    decenas = [
        '',
        '',
        'VEINTE',
        'TREINTA',
        'CUARENTA',
        'CINCUENTA',
        'SESENTA',
        'SETENTA',
        'OCHENTA',
        'NOVENTA'
    ];

    centenas = [
        '',
        'CIENTO',
        'DOSCIENTOS',
        'TRESCIENTOS',
        'CUATROCIENTOS',
        'QUINIENTOS',
        'SEISCIENTOS',
        'SETECIENTOS',
        'OCHOCIENTOS',
        'NOVECIENTOS'
    ];

    convertirMenor100(n: number): string {
        if (n < 10) return this.unidades[n];
        if (n >= 10 && n < 20) return this.especiales[n - 10];

        if (n >= 20 && n < 30) {
            if (n === 20) return 'VEINTE';

            const veintis = [
                '',
                'VEINTIUNO',
                'VEINTIDÓS',
                'VEINTITRÉS',
                'VEINTICUATRO',
                'VEINTICINCO',
                'VEINTISÉIS',
                'VEINTISIETE',
                'VEINTIOCHO',
                'VEINTINUEVE'
            ];

            return veintis[n - 20];
        }

        const d = Math.floor(n / 10);
        const u = n % 10;

        return u === 0
            ? this.decenas[d]
            : `${this.decenas[d]} Y ${this.unidades[u]}`;
    }

    convertirMenor1000(n: number): string {
        if (n === 0) return '';
        if (n === 100) return 'CIEN';

        const c = Math.floor(n / 100);
        const resto = n % 100;

        return `${this.centenas[c]} ${this.convertirMenor100(resto)}`.trim();
    }

    convertirAnioATexto(n: number): string {
        if (n === 0) return 'CERO';

        if (n < 1000) {
            return this.convertirMenor1000(n);
        }

        const miles = Math.floor(n / 1000);
        const resto = n % 1000;

        let textoMiles = '';

        if (miles === 1) {
            textoMiles = 'MIL';
        } else {
            textoMiles = `${this.convertirMenor1000(miles)} MIL`;
        }

        return `${textoMiles} ${this.convertirMenor1000(resto)}`.trim();
    }

    stringToDate(fecha: string): Date | null {
        if (!fecha) {
            return null;
        }

        const [anio, mes, dia] = fecha.split('-').map(Number);

        return new Date(anio, mes - 1, dia);
    }
}

